import { createContext, useContext, useEffect, useState } from "react"
import { gql, useLazyQuery } from '@apollo/client'
const SearchContext = createContext(undefined)


const OPERATION_FOLD_CHILDREN = gql`
    query GetAccounts($sf_id: String!) {
        accounts: childrenAccount(sf_id: $sf_id) {
            id
            name
            sf_parent_id
            sf_id
            nb_children
            is_site
            state
        }
    }
`

const useFold = () => {
  const [node, setNode] = useState(null)
  const [fetchedAccounts, setFetchedAccounts] = useState([])
  const [fetchChildren, isLoading, error] = useLazyQuery(OPERATION_FOLD_CHILDREN, {
    fetchPolicy: 'no-cache'
  })


  const fetch = async (node) => {
    const {data: { accounts }} = await fetchChildren({
      variables: {
        sf_id: node.internalId
      }
    })
    const hierarchie = node.data.hierarchie
    const newAccounts = accounts
      .map(account => ({...account, hierarchie: [...hierarchie, account.sf_id]}))
      .filter(account => fetchedAccounts.findIndex(({sf_id}) => sf_id === account.sf_id) === -1)
    setFetchedAccounts([...fetchedAccounts, ...newAccounts])

  }


  const handleToggle = async (node) => {
    setNode(node)
    await fetch(node.data)
    setNode(null)
  }

  return {
    activeNode: node,
    toggle: handleToggle,
    accounts: fetchedAccounts,
    reset: () => setFetchedAccounts([])
  }
}

export const useSearchContext = () => {
  const ctx = useContext(SearchContext)

  if (!ctx) {
    throw Error('useSearchContext must be use inside TreeProvider')
  }

  return ctx
}

const SearchProvider = ({name, children}) => {
  const apiFold = useFold()
  useEffect(() => {
    apiFold.reset()
  }, [name])
  return (
    <SearchContext.Provider
      value={{
        apiFold
      }}
      >
      {children}
    </SearchContext.Provider>
  )
}

export default SearchProvider
